<rt-dialog-header>
  <div layout-full-width>
    <div layout layout-space-between>
      <rt-heading variant="heading large-x-dialog-header">{{
        translationKey.dialog_2fa_sms.step_2.header | translate
      }}</rt-heading>
      <span layout layout-align-items-center margin-left-auto>
        {{ translationKey.dialog_2fa_sms.step_2.header_step | translate }}
      </span>
    </div>
    <span
      >{{ translationKey.dialog_2fa_sms.step_2.header_description | translate }}
      <a (click)="resendCode()">{{
        translationKey.dialog_2fa_sms.step_2.resend | translate
      }}</a></span
    >
  </div>
</rt-dialog-header>
<rt-dialog-body variant="white">
  <div layout-vertical>
    <rt-infobox
      [type]="'success'"
      [isDismissible]="false"
      [iconName]="'check'"
      padding-bottom-small-x
    >
      <div layout>
        <div
          [innerHTML]="
            translationKey.dialog_2fa_sms.step_2.code_sent | translate: { phone: phoneNumber() }
          "
        ></div>
      </div>
    </rt-infobox>
    <rt-label>{{ translationKey.dialog_2fa_sms.step_2.activation_code | translate }}</rt-label>
    <rt-code-input (clearError)="onClearError()" [formControl]="codeControl" [error]="codeError" />
    @if (isWarningVisible) {
      <rt-infobox
        [type]="'warning'"
        [iconName]="'warning'"
        [heading]="translationKey.dialog_2fa_sms.step_2.warning_title | translate"
        [isDismissible]="false"
        margin-top-small
      >
        <div
          [innerHTML]="
            translationKey.dialog_2fa_sms.step_2.warning_description
              | translate: { link: translationKey.dialog_2fa_sms.step_2.security_link | translate }
          "
        ></div>
      </rt-infobox>
    }
  </div>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true" variant="white">
  <rt-button (click)="onGoBackClick()" variant="outline" class="optional">
    <rt-icon name="chevron-left" />
    <span>{{ translationKey.common.goBack | translate }}</span>
  </rt-button>
  <rt-button (click)="onCancelClick()" variant="plain">{{
    translationKey.common.cancel | translate
  }}</rt-button>
  <rt-button
    [disabled]="codeControl.value.length !== 6"
    (click)="enable()"
    [loading]="isLoading"
    variant="primary"
  >
    {{ translationKey.dialog_2fa_sms.step_2.set_up_now | translate }}
  </rt-button>
</rt-dialog-footer>
